import type { ComponentType } from "react";

/**
 * The view registry: the single map from a view key to its React component, each
 * imported lazily so a page ships only its own chunk to the browser. Used by both
 * the SSR entry (entry-server.tsx) and the browser entry (main.tsx).
 */
// Named `views.ts` (not `client.ts`) deliberately: Borealis auto-discovers
// `src/**/client.*` as island client *entries* (see vite.config.ts), so that
// name is reserved. This is the client-side counterpart to routes.ts. Adding a
// page means adding one line here, one in routes.ts, and the route's own `view`
// key — see docs/adr/0001-frontend-page-structure.md.
export const views = {
	makes: () => import("./views/makes/view"),
	make: () => import("./views/make/view"),
	model: () => import("./views/model/view"),
	configurator: () => import("./views/configurator/view"),
} as const;

export type ViewKey = keyof typeof views;

// The props a given view expects, derived from its component so a route's
// loader return type is checked against what the view actually renders.
export type ViewProps<K extends ViewKey> =
	Awaited<ReturnType<(typeof views)[K]>> extends { default: ComponentType<infer P> } ? P : never;
